import { IRoleEnum } from "@interfaces";
import { createRoute } from "@routes/utils";

import { plansManagementRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";

const permission = [IRoleEnum.SUPER_ADMIN];

const plansManagementRouteMetadata: IRouteMetadataObj<
  typeof plansManagementRoutesObj
> = {
  list: {
    title: "plansManagement.index.title",
    description: "empty",
    lazy: () => import("@pages/plansManagement/table/page"),
    mode: "index",
    type: "main",
    icon: "StarLine",
    breadcrumbs: [],
    permission,
  },
  create: {
    title: "plansManagement.create.title",
    description: "empty",
    lazy: () => import("@/pages/plansManagement/form/page"),
    mode: "create",
    type: "inner",
    icon: "AddLine",
    breadcrumbs: [],
    permission,
  },
  edit: {
    title: "plansManagement.edit.title",
    description: "empty",
    lazy: () => import("@/pages/plansManagement/form/page"),
    mode: "edit",
    type: "inner",
    icon: "EditLine",
    breadcrumbs: [],
    permission,
  },
  view: {
    title: "plansManagement.view.title",
    description: "empty",
    lazy: () => import("@/pages/plansManagement/form/page"),
    mode: "view",
    type: "inner",
    icon: "EyeLine",
    breadcrumbs: [],
    permission,
  },
};

export const plansManagementRoutes = createRoute<
  typeof plansManagementRoutesObj
>(plansManagementRoutesObj, plansManagementRouteMetadata);
